import { render } from "./Edit.vue?vue&type=template&id=458c4490&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=458c4490&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-458c4490"

export default script